import React from 'react';
import styled from 'styled-components';

const Back = styled.div`
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
  width: 1920px;
  height: 1080px;
`;

export const PopupBack = ({children}) => {
  return (
    <Back>{children}</Back>
  );
};